import { memo } from 'react'
import QuickTradeConditionalEntry, { type QuickTradeConditionalEntryProps } from './QuickTradeConditionalEntry'
import QuickTradeConditionalLastPrice from './QuickTradeConditionalLastPrice'

export type QuickTradeConditionalEntryWithLiveQuoteProps = Omit<
    QuickTradeConditionalEntryProps,
    'lastPrice' | 'lastVolume'
> & {
    liveQuoteSecurityKey: string
    useZeroQuote?: boolean
}

const QuickTradeConditionalEntryWithLiveQuote: React.FC<QuickTradeConditionalEntryWithLiveQuoteProps> = ({
    liveQuoteSecurityKey,
    useZeroQuote = false,
    ...entryProps
}) => (
    <QuickTradeConditionalLastPrice securityKey={liveQuoteSecurityKey} useZeroQuote={useZeroQuote}>
        {({ lastPrice, lastVolume }) => (
            <QuickTradeConditionalEntry {...entryProps} lastPrice={lastPrice} lastVolume={lastVolume} />
        )}
    </QuickTradeConditionalLastPrice>
)

export default memo(QuickTradeConditionalEntryWithLiveQuote)
